import React, { useState, useEffect, useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Checkbox, Col, Form, Button, Input } from 'antd';
import { useAuth } from '@BUP/hooks';
import { ModeBupContext } from '@BUP/contexts';
import { ECE } from '@BUP/constants';

const CommentForm = ({ onSendMessage, onClickUpdateChat }) => {
  const [form] = Form.useForm();
  const [, forceUpdate] = useState();
  const [, setError] = useState(null);
  const [t] = useTranslation();

  const { user } = useAuth();
  const userRolType = user?.roles?.type;
  const { checkboxState, onChangeCheckBox } = useContext(ModeBupContext);

  useEffect(() => {
    forceUpdate({});
  }, []);

  const onSubmit = async (values) => {
    try {
      const comment = {
        content: values?.message || '',
        anonymus: values?.anonymous,
      };
      onSendMessage(comment);
      form.resetFields();
      setError(null);
    } catch (e) {
      console.log('CommentForm error', e);
      setError(e);
    }
  };
  return (
    <div className="send-comment-form-container">
      <Row>
        <Col xs={24} className="form-wrapper">
          <Form layout="vertical" form={form} onFinish={onSubmit}>
            <Form.Item
              name="message"
              rules={[
                {
                  required: true,
                  message: t('pages.modeBup.chatbox.messageRequired'),
                },
              ]}
            >
              <Input.TextArea
                size="large"
                placeholder={t('pages.modeBup.chatbox.chatPlaceHolder')}
                autoSize={{ minRows: 2, maxRows: 3 }}
              />
            </Form.Item>
            {userRolType !== ECE ? (
              <Form.Item
                name="anonymous"
                valuePropName="checked"
                onChange={onChangeCheckBox}
                initialValue={checkboxState}
              >
                <Checkbox
                  style={{
                    display: 'flex',
                    justifyContent: 'start',
                    alignItems: 'center',
                  }}
                >
                  {checkboxState
                    ? t('pages.modeBup.chatbox.anonymousCheckBoxState1')
                    : t('pages.modeBup.chatbox.anonymousCheckBoxState2')}
                </Checkbox>
              </Form.Item>
            ) : null}

            <Row type="flex" justify="end" align="middle">
              <Col xs={24} lg={18}>
                <Button
                  shape="round"
                  style={{ fontWeight: 'bold', marginTop: 10, color: 'grey' }}
                  size="large"
                  onClick={onClickUpdateChat}
                >
                  {t('pages.modeBup.chatbox.buttonText2')}
                </Button>
              </Col>
              <Col xs={24} lg={6}>
                <Form.Item shouldUpdate style={{ margin: 0 }}>
                  {() => (
                    <Button
                      type="primary"
                      style={{
                        minWidth: 150,
                        marginTop: 10,
                        fontWeight: 'bold',
                      }}
                      size="large"
                      htmlType="submit"
                      shape="round"
                      disabled={
                        form
                          .getFieldsError()
                          .filter(({ errors }) => errors.length).length
                      }
                    >
                      {t('pages.modeBup.chatbox.buttonText1')}
                    </Button>
                  )}
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Col>
      </Row>
    </div>
  );
};

export default CommentForm;
